import React, { useEffect, useMemo, useState } from 'react';
import { WidgetHelper } from '../WidgetHelper';
import { MultimediaService } from '../../Services';
import { IMultimedia } from '../../Models/Multimedia/IMultimedia';

interface IMultimediaBandWidgetProps {
    area: string;
    tagIds: string;
    homeUrl: string;
}

export const MultimediaBandWidget: React.FC<IMultimediaBandWidgetProps> = ({
    area,
    tagIds,
    homeUrl,
}) => {
    const [multimedias, setMultimedias] = useState<IMultimedia[]>([]);

    const parsedTagIds = useMemo<number[] | null>(() => {
        if (!tagIds) return null;

        try {
            return JSON.parse(tagIds) as number[];
        } catch {
            return null;
        }
    }, [tagIds]);

    useEffect(() => {
        const fetchMultimedias = async () => {
            const medias = await MultimediaService.getAllMultimedias({
                page: 1,
                pageSize: 8,
                target: area,
                searchText: null,
                tagIds: parsedTagIds,
                themeIds: null,
            });

            setMultimedias(medias.multimediaContents ?? []);
        };

        void fetchMultimedias();
    }, [area, parsedTagIds]);

    const displayedMultimedias = useMemo(
        () =>
            [...multimedias]
                .sort(
                    (a, b) =>
                        new Date(b.creationDate).getTime() -
                        new Date(a.creationDate).getTime()
                )
                .slice(0, 8),
        [multimedias]
    );

    if (displayedMultimedias.length === 0) {
        return null;
    }

    return (
        <div className="media-band d-flex justify-content-center">
            {displayedMultimedias.map((item) => (
                <a
                    href={`${homeUrl}media?reference=${item.id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="item d-flex align-items-end"
                    style={{
                        backgroundImage: `url(${item.thumbnailUrl})`,
                    }}
                    key={item.id}
                >
                    <span>{item.title}</span>
                </a>
            ))}
        </div>
    );
};

WidgetHelper.register(MultimediaBandWidget, 'multimedia-band-widget');
